import React, { useEffect } from "react";
//functions
import getCookieParam from "../Functions/getCookieParam";
//css & images
import redArrow from "../Images/red-arrow.svg";
import greyArrow from "../Images/grey-arrow.svg";

const breadcrumbsWrapper = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    gridColumnGap: "10px",
}

const greenBreadcrumb = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#fff",
    fontWeight: 600,
    width: "33%",
    height: "30px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundImage: `url(${redArrow})`,
    cursor: "pointer"
}

const greyBreadcrumb = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "#767477",
    width: "33%",
    height: "30px",
    backgroundRepeat: "no-repeat",
    backgroundSize: "contain",
    backgroundImage: `url(${greyArrow})`,
}

const Breadcrumbs = () => {
    useEffect(() => {
        document.getElementById('1').onclick = () => { window.location.pathname = `/${getCookieParam('partnerName')}/phone-number-verification`; }
        document.getElementById('2').onclick = () => { window.location.pathname = `/${getCookieParam('partnerName')}/whatsapp-onboarding`; }
        if (getCookieParam('statusPercent') >= 70)
            document.getElementById('3').onclick = () => { window.location.pathname = '/check-status'; }
    });

    return (
        <>
            <div style={breadcrumbsWrapper}>
                <div id="1" style={greenBreadcrumb} >Phone Number Verification</div>
                <div id="2" style={(window.location.pathname.includes('whatsapp-onboarding') || window.location.pathname.includes('check-status')) ? greenBreadcrumb : greyBreadcrumb}>WhatsApp Onboarding</div>
                <div id="3" style={(window.location.pathname.includes('check-status')) ? greenBreadcrumb : greyBreadcrumb}>Status Check</div>
            </div>
        </>
    )
}

export default Breadcrumbs;